import { render } from "./scenario-partner-distribution.vue?vue&type=template&id=20248693&scoped=true&ts=true"
import script from "./scenario-partner-distribution.vue?vue&type=script&lang=ts"
export * from "./scenario-partner-distribution.vue?vue&type=script&lang=ts"

import "./scenario-partner-distribution.vue?vue&type=style&index=0&id=20248693&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20248693"]])

export default __exports__